import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {PartialWorkout} from '../../../../Models/PartialWorkout';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    partialWorkout: PartialWorkout;
    className?: string;
}

export const Share: FunctionComponent<OwnProps> = ({partialWorkout, className}) => {
    const [copied, setCopied] = useState(false);

    return (
        <div className={classNames('card', className)}>
            <div className="card-title">
                <h5>Share</h5>
            </div>
            <div className="card-body">
                <p>Share this workout, copy this link by clicking on it</p>
                <div className="input-group mb-3">
                    <input type="text" className="form-control" value={partialWorkout.share_url} readOnly />
                    <button
                        className="btn btn-primary input-group-text"
                        style={{width: 80}}
                        onClick={() => {
                            navigator.clipboard.writeText(partialWorkout.share_url).then(() => {
                                setCopied(true);
                            });
                        }}
                    >
                        {copied ? <i className="bi bi-check" /> : 'Copy'}
                    </button>
                </div>
            </div>
        </div>
    );
};
